
(function () {
  'use strict';

  function initPickNMix() {
    document.querySelectorAll('.ls-pnm').forEach(builder => {
      if (builder.dataset.initialized === 'true') return;
      builder.dataset.initialized = 'true';

      /* =========================================
         ELEMENTS AND STATE
      ========================================= */

      const cards = Array.from(
        builder.querySelectorAll('.ls-pnm__product')
      );

      const selections = new Map();

      const searchInput = builder.querySelector('.ls-pnm__search');
      const clearSearchButton = builder.querySelector('.ls-pnm__search-clear');
      const productGrid = builder.querySelector('.ls-pnm__products');

      const filterButtons = Array.from(
        builder.querySelectorAll('.ls-pnm__filter')
      );

      const sidebar = builder.querySelector('.ls-pnm__sidebar');
      const selectedSection = builder.querySelector('.ls-pnm__selected');
      const selectedList = builder.querySelector('.ls-pnm__selected-list');

      const mobileBar = builder.querySelector('.ls-pnm__mobile-bar');
      const drawer = builder.querySelector('.ls-pnm__mobile-drawer');
      const overlay = builder.querySelector('.ls-pnm__mobile-overlay');
      const drawerClose = builder.querySelector('.ls-pnm__drawer-close');
      const drawerList = builder.querySelector('.ls-pnm__drawer-list');
      const drawerSelected = builder.querySelector('.ls-pnm__drawer-selected');
      const drawerEmpty = builder.querySelector('.ls-pnm__drawer-empty');

      const checkoutButtons = Array.from(
        builder.querySelectorAll('.ls-pnm__checkout')
      );

      const surprisePanels = Array.from(
        builder.querySelectorAll('.ls-pnm__surprise')
      );

      const ingredientsOverlay = builder.querySelector(
        '.ls-pnm__ingredients-overlay'
      );

      const ingredientsModal = builder.querySelector(
        '.ls-pnm__ingredients-modal'
      );

      const ingredientsProduct = builder.querySelector(
        '.ls-pnm__ingredients-product'
      );

      const ingredientsText = builder.querySelector(
        '.ls-pnm__ingredients-text'
      );

      const ingredientsClose = builder.querySelector(
        '.ls-pnm__ingredients-close'
      );

      let activeFilter = null;
      let surpriseWeight = 500;
      let isAddingToCart = false;

      let previousDrawerFocus = null;
      let previousIngredientsFocus = null;

      const moneyFormatter = new Intl.NumberFormat('en-NZ', {
        style: 'currency',
        currency: 'NZD'
      });

      function money(cents) {
        return moneyFormatter.format(cents / 100);
      }

      function normalise(value) {
        return String(value || '').toLocaleLowerCase().trim();
      }

      /* =========================================
         PREPARE PRODUCT DATA
      ========================================= */

      const productData = cards.map(card => {
        const controls = card.querySelector('.ls-pnm__controls');

        const fields = {
          title:
            card.dataset.pnmTitle ||
            card.querySelector('.ls-pnm__name')?.textContent ||
            '',

          flavor: card.dataset.pnmFlavor || '',
          texture: card.dataset.pnmTexture || '',
          'package-type': card.dataset.pnmPackageType || '',
          'chocolate-type': card.dataset.pnmChocolateType || '',
          category: card.dataset.pnmCategory || ''
        };

        const searchableFields = {};

        Object.keys(fields).forEach(key => {
          searchableFields[key] = normalise(fields[key]);
        });

        searchableFields.all =
          Object.values(searchableFields).join(' ');

        return {
          card,
          variantId: card.dataset.variantId || '',
          name: controls?.dataset.name || '',
          price: Number(controls?.dataset.price),
          image: card.querySelector('.ls-pnm__image img')?.src || '',
          fields: searchableFields
        };
      });

      const productByVariant = new Map(
        productData
          .filter(item => item.variantId)
          .map(item => [item.variantId, item])
      );

      /* =========================================
         CART ERROR MESSAGES
      ========================================= */

      const cartErrors = checkoutButtons.map(button => {
        const error = document.createElement('p');

        error.className = 'ls-pnm__cart-error';
        error.setAttribute('role', 'alert');
        error.hidden = true;

        button.insertAdjacentElement('afterend', error);

        return error;
      });

      function showCartError(message) {
        cartErrors.forEach(error => {
          error.textContent = message;
          error.hidden = false;
        });
      }

      function clearCartErrors() {
        cartErrors.forEach(error => {
          error.textContent = '';
          error.hidden = true;
        });
      }

      /* =========================================
         SEARCH AND CATEGORY FILTERS
      ========================================= */

      const noResults = document.createElement('div');

      noResults.className = 'ls-pnm__no-results';
      noResults.textContent =
        'No lollies found! Try another search.';
      noResults.hidden = true;

      productGrid?.insertAdjacentElement('afterend', noResults);

      function filterProducts() {
        const searchTerm = normalise(searchInput?.value);

        if (clearSearchButton) {
          clearSearchButton.hidden = !searchInput?.value;
        }

        const matchSource =
          activeFilter?.dataset.matchSource || 'all';

        const matchWords =
          (activeFilter?.dataset.matchValues || '')
            .split(',')
            .map(normalise)
            .filter(Boolean);

        let visibleCount = 0;

        productData.forEach(item => {
          const matchesSearch =
            item.fields.all.includes(searchTerm);

          const filterText =
            item.fields[matchSource] || '';

          const matchesCategory =
            !activeFilter ||
            (
              matchWords.length > 0 &&
              matchWords.some(word =>
                filterText.includes(word)
              )
            );

          const visible =
            matchesSearch && matchesCategory;

          item.card.hidden = !visible;

          if (visible) visibleCount++;
        });

        if (noResults) {
          noResults.hidden = visibleCount > 0;
        }
      }

      function activateFilter(button) {
        activeFilter =
          button?.dataset.pnmFilter === 'all'
            ? null
            : button;

        filterButtons.forEach(filterButton => {
          const active = filterButton === button;

          filterButton.classList.toggle(
            'is-active',
            active
          );

          filterButton.setAttribute(
            'aria-pressed',
            String(active)
          );
        });

        filterProducts();
      }

      filterButtons.forEach(button => {
        button.addEventListener('click', () => {
          if (searchInput) {
            searchInput.value = '';
          }

          activateFilter(button);
        });
      });

      searchInput?.addEventListener(
        'input',
        filterProducts
      );

      clearSearchButton?.addEventListener('click', () => {
        if (!searchInput) return;

        searchInput.value = '';

        filterProducts();
        searchInput.focus();
      });

      filterProducts();

      /* =========================================
         MOBILE DRAWER
      ========================================= */

      function setDrawerOpen(open) {
        if (!drawer || !overlay) return;

        if (open) {
          previousDrawerFocus = document.activeElement;
        }

        drawer.classList.toggle('is-open', open);
        overlay.classList.toggle('is-open', open);

        overlay.hidden = !open;

        drawer.setAttribute(
          'aria-hidden',
          String(!open)
        );

        mobileBar?.setAttribute(
          'aria-expanded',
          String(open)
        );

        document.body.classList.toggle(
          'ls-pnm-drawer-open',
          open
        );

        if (open) {
          drawer.focus();
        } else {
          previousDrawerFocus?.focus?.();
        }
      }

      mobileBar?.addEventListener('click', () => {
        setDrawerOpen(true);
      });

      drawerClose?.addEventListener('click', () => {
        setDrawerOpen(false);
      });

      overlay?.addEventListener('click', () => {
        setDrawerOpen(false);
      });

      drawer?.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          setDrawerOpen(false);
        }
      });

      /* =========================================
         INGREDIENTS AND ALLERGENS
      ========================================= */

      function closeIngredients() {
        if (
          !ingredientsOverlay ||
          ingredientsOverlay.hidden
        ) {
          return;
        }

        ingredientsOverlay.hidden = true;

        document.body.style.overflow = '';

        previousIngredientsFocus?.focus?.();
      }

      builder
        .querySelectorAll('.ls-pnm__ingredients-link')
        .forEach(button => {
          button.addEventListener('click', () => {
            if (!ingredientsOverlay) return;

            previousIngredientsFocus =
              document.activeElement;

            if (ingredientsProduct) {
              ingredientsProduct.textContent =
                button.dataset.ingredientsTitle || '';
            }

            if (ingredientsText) {
              ingredientsText.textContent =
                button.dataset.ingredientsText || '';
            }

            ingredientsOverlay.hidden = false;

            document.body.style.overflow = 'hidden';

            ingredientsModal?.focus();
          });
        });

      ingredientsClose?.addEventListener(
        'click',
        closeIngredients
      );

      ingredientsOverlay?.addEventListener(
        'click',
        event => {
          if (event.target === ingredientsOverlay) {
            closeIngredients();
          }
        }
      );

      ingredientsModal?.addEventListener(
        'keydown',
        event => {
          if (event.key === 'Escape') {
            closeIngredients();
          }
        }
      );

      /* =========================================
         PRODUCT CARD APPEARANCE
      ========================================= */

      function updateCard(card, quantity) {
        if (!card) return;

        const addButton =
          card.querySelector('.ls-pnm__add');

        const quantityControls =
          card.querySelector('.ls-pnm__quantity');

        const quantityValue =
          card.querySelector('.ls-pnm__quantity-value');

        card.classList.toggle(
          'is-selected',
          quantity > 0
        );

        if (addButton) {
          addButton.hidden = quantity > 0;
        }

        if (quantityControls) {
          quantityControls.hidden = quantity === 0;
        }

        // Display 1, 2, 3 instead of 100g, 200g, 300g.
        if (quantityValue) {
          quantityValue.textContent = String(quantity);
        }
      }

      /* =========================================
         SELECTED PRODUCTS
         DESKTOP AND MOBILE
      ========================================= */

      function populateSelectedList(list) {
        if (!list) return;

        const fragment =
          document.createDocumentFragment();

        selections.forEach(item => {
          const row = document.createElement('div');
          row.className = 'ls-pnm__selected-item';

          /* Product image */

          if (item.image) {
            const image = document.createElement('img');

            image.className =
              'ls-pnm__selected-image';

            image.src = item.image;
            image.alt = '';
            image.loading = 'lazy';

            row.appendChild(image);
          }

          /* Product details */

          const details = document.createElement('div');
          details.className =
            'ls-pnm__selected-details';

          const name = document.createElement('div');
          name.className = 'ls-pnm__selected-name';
          name.textContent = item.name;

          const meta = document.createElement('div');
          meta.className = 'ls-pnm__selected-meta';

          meta.textContent =
            `${item.quantity * 100}g · ` +
            money(item.quantity * item.price);

          details.append(name, meta);

          /* Quantity controls */

          const quantityControls =
            document.createElement('div');

          quantityControls.className =
            'ls-pnm__selected-quantity';

          const minus = document.createElement('button');

          minus.type = 'button';
          minus.dataset.quantityAction = 'minus';
          minus.dataset.variantId = item.variantId;
          minus.textContent = '−';

          minus.setAttribute(
            'aria-label',
            `Remove one 100g portion of ${item.name}`
          );

          const value = document.createElement('span');

          value.className =
            'ls-pnm__selected-quantity-value';

          value.textContent = String(item.quantity);

          const plus = document.createElement('button');

          plus.type = 'button';
          plus.dataset.quantityAction = 'plus';
          plus.dataset.variantId = item.variantId;
          plus.textContent = '+';

          plus.setAttribute(
            'aria-label',
            `Add one 100g portion of ${item.name}`
          );

          quantityControls.append(
            minus,
            value,
            plus
          );

          row.append(
            details,
            quantityControls
          );

          fragment.appendChild(row);
        });

        list.replaceChildren(fragment);
      }

      function renderSelectedItems() {
        populateSelectedList(selectedList);
        populateSelectedList(drawerList);

        const hasSelections =
          selections.size > 0;

        if (selectedSection) {
          selectedSection.hidden = !hasSelections;
        }

        if (drawerSelected) {
          drawerSelected.hidden = !hasSelections;
        }

        if (drawerEmpty) {
          drawerEmpty.hidden = hasSelections;
        }
      }

      /* =========================================
         LIVE TOTALS
      ========================================= */

      function updateSummary() {
        let portions = 0;
        let total = 0;

        selections.forEach(item => {
          portions += item.quantity;
          total += item.quantity * item.price;
        });

        const weight = portions * 100;
        const varieties = selections.size;

        /* Desktop */

        if (sidebar) {
          const stats =
            sidebar.querySelectorAll(
              '.ls-pnm__stat-value'
            );

          if (stats[0]) {
            stats[0].textContent = `${weight}g`;
          }

          if (stats[1]) {
            stats[1].textContent = varieties;
          }

          const totalElement =
            sidebar.querySelector(
              '.ls-pnm__total span:last-child'
            );

          if (totalElement) {
            totalElement.textContent = money(total);
          }

          const empty =
            sidebar.querySelector('.ls-pnm__empty');

          if (empty) {
            empty.hidden = varieties > 0;
          }
        }

        /* Mobile sticky bar */

        if (mobileBar) {
          const label =
            mobileBar.querySelector('span');

          if (label) {
            label.textContent =
              `Your Mix · ${varieties} ` +
              (
                varieties === 1
                  ? 'lolly'
                  : 'lollies'
              );
          }
        }

        /* Mobile drawer */

        if (drawer) {
          const weightElement =
            drawer.querySelector(
              '.ls-pnm__drawer-weight'
            );

          const varietiesElement =
            drawer.querySelector(
              '.ls-pnm__drawer-varieties'
            );

          const totalElement =
            drawer.querySelector(
              '.ls-pnm__drawer-total strong'
            );

          if (weightElement) {
            weightElement.textContent = `${weight}g`;
          }

          if (varietiesElement) {
            varietiesElement.textContent = varieties;
          }

          if (totalElement) {
            totalElement.textContent = money(total);
          }
        }

        checkoutButtons.forEach(button => {
          button.disabled =
            isAddingToCart || varieties === 0;

          if (!isAddingToCart) {
            button.textContent = 'Add to cart';
          }
        });

        renderSelectedItems();
      }

      /* =========================================
         QUANTITY MANAGEMENT
      ========================================= */

      function setQuantity(variantId, quantity) {
        const product =
          productByVariant.get(variantId);

        if (!product) return;

        const safeQuantity =
          Math.max(0, Math.floor(quantity));

        if (safeQuantity === 0) {
          selections.delete(variantId);
        } else {
          selections.set(variantId, {
            variantId,
            name: product.name,
            price: product.price,
            quantity: safeQuantity,
            image: product.image
          });
        }

        updateCard(
          product.card,
          safeQuantity
        );

        clearCartErrors();
        updateSummary();
      }

      /* Product card + and - */

      productData.forEach(product => {
        if (
          !product.variantId ||
          !Number.isFinite(product.price)
        ) {
          return;
        }

        product.card.addEventListener(
          'click',
          event => {
            const button = event.target.closest(
              'button[data-action]'
            );

            if (
              !button ||
              !product.card.contains(button) ||
              button.disabled ||
              isAddingToCart
            ) {
              return;
            }

            const current =
              selections.get(
                product.variantId
              )?.quantity || 0;

            switch (button.dataset.action) {
              case 'add':
              case 'plus':
                setQuantity(
                  product.variantId,
                  current + 1
                );
                break;

              case 'minus':
                setQuantity(
                  product.variantId,
                  current - 1
                );
                break;
            }
          }
        );
      });

      /* Desktop and mobile summary + and - */

      function handleSummaryQuantity(event) {
        if (isAddingToCart) return;

        const button = event.target.closest(
          'button[data-quantity-action]'
        );

        if (!button) return;

        const variantId =
          button.dataset.variantId;

        const current =
          selections.get(variantId)?.quantity || 0;

        if (
          button.dataset.quantityAction === 'plus'
        ) {
          setQuantity(
            variantId,
            current + 1
          );
        } else if (
          button.dataset.quantityAction === 'minus'
        ) {
          setQuantity(
            variantId,
            current - 1
          );
        }
      }

      selectedList?.addEventListener(
        'click',
        handleSummaryQuantity
      );

      drawerList?.addEventListener(
        'click',
        handleSummaryQuantity
      );

      /* =========================================
         SURPRISE ME
      ========================================= */

      function setSurpriseWeight(weight) {
        if (
          !Number.isFinite(weight) ||
          weight <= 0
        ) {
          return;
        }

        surpriseWeight = weight;

        surprisePanels.forEach(panel => {
          panel
            .querySelectorAll(
              '[data-surprise-weight]'
            )
            .forEach(button => {
              const active =
                Number(
                  button.dataset.surpriseWeight
                ) === weight;

              button.classList.toggle(
                'is-active',
                active
              );

              button.setAttribute(
                'aria-pressed',
                String(active)
              );
            });
        });
      }

      function showSurpriseMessage(message) {
        surprisePanels.forEach(panel => {
          const element = panel.querySelector(
            '.ls-pnm__surprise-message'
          );

          if (!element) return;

          element.textContent = message;
          element.hidden = !message;
        });
      }

      function generateSurpriseMix() {
        if (isAddingToCart) return;

        const portionsNeeded =
          surpriseWeight / 100;

        if (
          !Number.isInteger(portionsNeeded) ||
          portionsNeeded <= 0
        ) {
          showSurpriseMessage(
            'Please choose a valid mix size.'
          );
          return;
        }

        const eligibleProducts =
          productData.filter(product =>
            product.variantId &&
            Number.isFinite(product.price) &&
            product.price >= 0
          );

        if (
          eligibleProducts.length <
          portionsNeeded
        ) {
          showSurpriseMessage(
            'Not enough lollies available to create this size right now.'
          );
          return;
        }

        const shuffled = [...eligibleProducts];

        for (
          let i = shuffled.length - 1;
          i > 0;
          i--
        ) {
          const j = Math.floor(
            Math.random() * (i + 1)
          );

          [
            shuffled[i],
            shuffled[j]
          ] = [
            shuffled[j],
            shuffled[i]
          ];
        }

        const chosenProducts =
          shuffled.slice(
            0,
            portionsNeeded
          );

        /* Replace the existing mix */

        selections.clear();

        productData.forEach(product => {
          updateCard(product.card, 0);
        });

        chosenProducts.forEach(product => {
          selections.set(
            product.variantId,
            {
              variantId: product.variantId,
              name: product.name,
              price: product.price,
              quantity: 1,
              image: product.image
            }
          );

          updateCard(product.card, 1);
        });

        /* Clear search and filters */

        if (searchInput) {
          searchInput.value = '';
        }

        const allButton =
          filterButtons.find(
            button =>
              button.dataset.pnmFilter === 'all'
          );

        if (allButton) {
          activateFilter(allButton);
        } else {
          activeFilter = null;
          filterProducts();
        }

        clearCartErrors();
        updateSummary();
        showSurpriseMessage('');

        /* Update Surprise Me buttons */

        surprisePanels.forEach(panel => {
          const button =
            panel.querySelector(
              '.ls-pnm__surprise-button'
            );

          if (!button) return;

          button.textContent =
            '↻ Try another mix!';

          button.classList.remove(
            'is-mixing'
          );

          void button.offsetWidth;

          button.classList.add(
            'is-mixing'
          );
        });

        /* Open mobile drawer */

        if (
          window.matchMedia(
            '(max-width: 749px)'
          ).matches &&
          drawer &&
          mobileBar
        ) {
          setDrawerOpen(true);
        }
      }

      surprisePanels.forEach(panel => {
        panel
          .querySelectorAll(
            '[data-surprise-weight]'
          )
          .forEach(button => {
            button.addEventListener(
              'click',
              () => {
                setSurpriseWeight(
                  Number(
                    button.dataset.surpriseWeight
                  )
                );

                showSurpriseMessage('');
              }
            );
          });

        panel
          .querySelector(
            '.ls-pnm__surprise-button'
          )
          ?.addEventListener(
            'click',
            generateSurpriseMix
          );
      });

      setSurpriseWeight(500);

      /* =========================================
         SHOPIFY CART
      ========================================= */

      function getCartRoot() {
        const root =
          window.Shopify?.routes?.root || '/';

        return root.endsWith('/')
          ? root
          : `${root}/`;
      }

      function resetMix() {
        selections.clear();

        productData.forEach(product => {
          updateCard(product.card, 0);
        });

        updateSummary();
      }

      async function addMixToCart() {
        if (
          isAddingToCart ||
          selections.size === 0
        ) {
          return;
        }

        isAddingToCart = true;
        clearCartErrors();

        checkoutButtons.forEach(button => {
          button.disabled = true;
          button.textContent =
            'Adding to cart...';
        });

        /* Unique identifier for each mix */

        const mixId =
          `PNM-${Date.now()}-` +
          Math.random()
            .toString(36)
            .slice(2, 8);

        const items =
          Array.from(
            selections.values()
          ).map(item => ({
            id: Number(item.variantId),
            quantity: item.quantity,
            properties: {
              '_Pick n Mix Group': mixId
            }
          }));

        const invalidItem =
          items.some(item =>
            !Number.isSafeInteger(item.id) ||
            item.id <= 0 ||
            !Number.isInteger(item.quantity) ||
            item.quantity <= 0
          );

        if (invalidItem) {
          showCartError(
            'A selected lolly has invalid product information. ' +
            'Please refresh and try again.'
          );

          isAddingToCart = false;
          updateSummary();
          return;
        }

        const root = getCartRoot();

        /* Add items to Shopify */

        try {
          const response = await fetch(
            `${root}cart/add.js`,
            {
              method: 'POST',
              headers: {
                'Content-Type':
                  'application/json',
                'Accept':
                  'application/json'
              },
              body: JSON.stringify({
                items
              })
            }
          );

          if (!response.ok) {
            const result =
              await response
                .json()
                .catch(() => ({}));

            throw new Error(
              result.description ||
              result.message ||
              'We could not add your mix. Please try again.'
            );
          }

        } catch (error) {
          console.error(
            'Pick n Mix cart error:',
            error
          );

          showCartError(
            error.message ||
            'We could not add your mix. Please try again.'
          );

          isAddingToCart = false;
          updateSummary();
          return;
        }

        /* Shopify accepted the mix */

        setDrawerOpen(false);

        isAddingToCart = false;

        resetMix();

        /* Refresh Canopy cart drawer */

        try {
          const cartDrawer =
            document.querySelector(
              'cart-drawer'
            );

          if (
            cartDrawer &&
            typeof cartDrawer
              .refreshCartDrawer === 'function'
          ) {
            await cartDrawer
              .refreshCartDrawer(true);

            document.dispatchEvent(
              new CustomEvent(
                'dispatch:cart-drawer:open'
              )
            );

          } else {
            window.location.assign(
              `${root}cart`
            );
          }

        } catch (error) {
          console.warn(
            'Pick n Mix added, but cart drawer refresh failed:',
            error
          );

          window.location.assign(
            `${root}cart`
          );
        }
      }

      checkoutButtons.forEach(button => {
        button.addEventListener(
          'click',
          addMixToCart
        );
      });


      /* =========================================
         HIGHLIGHT LINKED PRODUCT
      ========================================= */

      function highlightLinkedProduct() {
        const params = new URLSearchParams(
          window.location.search
        );

        const variantId = params.get('highlight');

        if (!variantId) return;

        const product = productByVariant.get(variantId);

        if (!product) return;

        const card = product.card;

        // Ensure the product is visible even if a
        // category filter was previously selected.
        if (searchInput) {
          searchInput.value = '';
        }

        const allButton = filterButtons.find(
          button => button.dataset.pnmFilter === 'all'
        );

        if (allButton) {
          activateFilter(allButton);
        } else {
          activeFilter = null;
          filterProducts();
        }

        // Add temporary visual highlighting.
        card.classList.add('ls-pnm__highlighted');

        // Wait until the page layout is ready.
        window.requestAnimationFrame(() => {
          window.setTimeout(() => {
            card.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            });
          }, 250);
        });

        // Remove highlight after six seconds.
        window.setTimeout(() => {
          card.classList.remove('ls-pnm__highlighted');
        }, 6000);
      }

      /* =========================================
         INITIAL STATE
      ========================================= */

      updateSummary();
      highlightLinkedProduct();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initPickNMix
    );
  } else {
    initPickNMix();
  }

  document.addEventListener(
    'shopify:section:load',
    initPickNMix
  );
})();